"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * "Sign-in couldn't load", for a browser that blocks Clerk (TX-5483). Shown by
 * /landing's choose step and the email step once useClerkUnavailable says the
 * wait has run out — one copy of the notice for both.
 */
export function SignInCouldNotLoadNotice() {
  const $ = _c(4);
  const t = useTranslations("Authentication");
  let t0;
  if ($[0] !== t) {
    t0 = t("landing.signInCouldNotLoad");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Alert variant="destructive"><AlertDescription>{t0}</AlertDescription></Alert>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}